import React, { useEffect, useState } from 'react';
import { Cake, Gift, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { Employee } from '../../types/hr.types';
import { mockEmployees } from '../../utils/mockData';
import { isBirthdayToday } from '../../utils/dateUtils';
import { ShowMoreModal } from '../ui/ShowMoreModal';
const MAX_VISIBLE = 4;
export function BirthdaysTodayWidget() {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      const todayBirthdays = mockEmployees.filter(e => e.isActive && isBirthdayToday(e.birthday));
      setEmployees(todayBirthdays);
      setIsLoading(false);
    }, 600);
    return () => clearTimeout(timer);
  }, []);
  const visibleEmployees = employees.slice(0, MAX_VISIBLE);
  const hasMore = employees.length > MAX_VISIBLE;
  const remainingCount = employees.length - MAX_VISIBLE;
  const EmployeeItem = ({
    employee
  }: {
    employee: Employee;
  }) => <div className="flex items-center gap-4 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-958">
      <img src={employee.photoUrl} alt={employee.name} className="h-12 w-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-959" />
      <div className="flex-1 min-w-0" data-id="element-960">
        <p className="text-sm font-medium text-gray-900 truncate" data-id="element-961">
          {employee.name}
        </p>
        <p className="text-xs text-gray-500 truncate" data-id="element-962">{employee.department}</p>
      </div>
      <Gift className="h-5 w-5 text-pink-400" data-id="element-963" />
    </div>;
  if (isLoading) {
    return <Card title="Birthdays Today" icon={<Cake className="h-5 w-5 text-pink-500" data-id="element-965" />} data-id="element-964">
        <div className="space-y-4 animate-pulse" data-id="element-966">
          {[1, 2].map(i => <div key={i} className="flex items-center gap-4" data-id="element-967">
              <div className="h-10 w-10 rounded-full bg-gray-200" data-id="element-968" />
              <div className="flex-1 space-y-2" data-id="element-969">
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-970" />
                <div className="h-3 w-16 bg-gray-200 rounded" data-id="element-971" />
              </div>
            </div>)}
        </div>
      </Card>;
  }
  return <>
      <Card title="Birthdays Today" icon={<Cake className="h-5 w-5 text-pink-500" data-id="element-973" />} data-id="element-972">
        {employees.length > 0 ? <div className="space-y-2" data-id="element-974">
            {visibleEmployees.map(employee => <EmployeeItem key={employee.id} employee={employee} data-id="element-975" />)}
            {hasMore && <button onClick={() => setShowModal(true)} className="w-full mt-2 py-2 px-3 text-sm font-medium text-orange-600 hover:text-orange-700 hover:bg-orange-50 rounded-lg transition-colors flex items-center justify-center gap-1" data-id="element-976">
                Show {remainingCount} more
                <ChevronRight className="h-4 w-4" data-id="element-977" />
              </button>}
          </div> : <div className="text-center py-8 text-gray-500" data-id="element-978">
            <p className="text-2xl mb-2" data-id="element-979">🎉</p>
            <p data-id="element-980">No birthdays today!</p>
          </div>}
      </Card>
      <ShowMoreModal isOpen={showModal} onClose={() => setShowModal(false)} title={`All Birthdays Today (${employees.length})`} data-id="element-981">
        <div className="space-y-2" data-id="element-982">
          {employees.map(employee => <EmployeeItem key={employee.id} employee={employee} data-id="element-983" />)}
        </div>
      </ShowMoreModal>
    </>;
}